var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"theme--light v-label",staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm.label))]),_c(_vm.field.component,{tag:"v-component",attrs:{"record":_vm.field}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }